import { render, staticRenderFns } from "./ConsultasCadastrosListagem.vue?vue&type=template&id=73a4c9aa&scoped=true&lang=pug&"
import script from "./ConsultasCadastrosListagem.vue?vue&type=script&lang=js&"
export * from "./ConsultasCadastrosListagem.vue?vue&type=script&lang=js&"
import style0 from "./ConsultasCadastrosListagem.vue?vue&type=style&index=0&id=73a4c9aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4c9aa",
  null
  
)

export default component.exports